import { render } from "./RichTextBubbleMenu.vue?vue&type=template&id=02f55ed2"
import script from "./RichTextBubbleMenu.vue?vue&type=script&lang=js"
export * from "./RichTextBubbleMenu.vue?vue&type=script&lang=js"

import "./RichTextBubbleMenu.vue?vue&type=style&index=0&id=02f55ed2&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__